<template>
    <div :style="style">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
            <i class="weui-loading weui-icon_toast"></i>
            <p class="weui-toast__content">数据加载中</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "WeuiLoadMore",
    props: [
        'show',       // true/false
    ],
    computed: {
        style() {
            return this.show ? 'opacity: 1' : 'opacity: 0; display: none';
        }
    }
};
</script>
